// this is a hack around webpack CORS worker limitations https://github.com/webpack/webpack/discussions/14648#discussioncomment-1589272
// TODO: This can be done with the output.workerPublicPath Webpack option, but we would have to set it to different CDN URL for each environment
export class CorsWorker {
  constructor(private url: string | URL, private options?: WorkerOptions) {}

  createWorker(): Worker {
    const absoluteUrl = new URL(this.url, window.location.href).toString();
    const workerSource = `\
    const urlString = ${JSON.stringify(absoluteUrl)}
    const originURL = new URL(urlString)
    const isValidUrl = (urlString) => {
        try { return Boolean(new URL(urlString, originURL)) } catch(e) { return false }
    }
    const originalImportScripts = self.importScripts
    self.importScripts = (url) => {
        if(url.startsWith("blob:") && isValidUrl(url.replace("blob:", ""))){
          const urlWithoutBlob = url.replace("blob:", "")
          const { pathname } = new URL(urlWithoutBlob, originURL)
          url = pathname && pathname.substring(1)
        }
        originalImportScripts.call(self, new URL(url, originURL).toString())
    }
    importScripts(urlString);
    `;
    const blob = new Blob([workerSource], { type: 'application/javascript' });
    const objectURL = URL.createObjectURL(blob);
    const worker = new Worker(objectURL, this.options);
    URL.revokeObjectURL(objectURL);
    return worker;
  }
}
